import Raven from 'raven-js';
import { GET_PUBLIC_FEATURE_FLAGS } from '../queries/featureFlagQueries';
import { getBrowserLocale } from '../utils/getPreferredLanguage';
import { getUtk } from 'pricing-pages-ui/earlyRequester/earlyRequesterUtils';
import { DEFAULT_CHIRP_TIMEOUT } from '../constants/chirpDefaults';
import { dataFetchingClient } from '../dataFetchingClient';
import { getCountryCodeFromLocale } from '../utils/countryCodeUtils';
export function fetchPublicPricingPageDetails() {
  const browserLocale = getBrowserLocale();
  const utk = getUtk() || '';
  const preferredCountryCode = getCountryCodeFromLocale();
  dataFetchingClient.query({
    query: GET_PUBLIC_FEATURE_FLAGS,
    variables: {
      utk,
      browserLocale,
      preferredCountryCode
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    }
  }).catch(error => {
    Raven.captureException(error, {
      fingerprint: ['failed-to-fetch-public-feature-flags']
    });
  });
}